import { render, staticRenderFns } from "./CustomDomainPaywall.vue?vue&type=template&id=31248750&scoped=true&"
import script from "./CustomDomainPaywall.vue?vue&type=script&lang=js&"
export * from "./CustomDomainPaywall.vue?vue&type=script&lang=js&"
import style0 from "./CustomDomainPaywall.vue?vue&type=style&index=0&id=31248750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31248750",
  null
  
)

export default component.exports